import CloseIcon from '@assets/images/common/icon/close.svg';
import { Article } from '@src/api/types/article';
import Modal from '@src/layouts/Modal';
import { useEffect } from 'react';

interface ModalProps {
  isOpen: boolean;
  items: Article[];
  checkedItems: Set<number>;
  onToggle: (id: number) => void;
  onApply: (selectedItems: Article[]) => void;
  onClose: () => void;
  currentArticle?: Article;
}

const RelatedArticleModal: React.FC<ModalProps> = ({
  isOpen,
  items,
  checkedItems,
  onToggle,
  onApply,
  onClose,
  currentArticle,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  const filteredItems = items.filter((item) => item.id !== currentArticle?.id);

  const handleApply = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    onApply(filteredItems.filter((item) => checkedItems.has(item.id)));
  };

  return (
    <div>
      <Modal width='656px'>
        <div className='flex grow flex-col gap-8 px-8 py-10'>
          <div className='flex justify-between border-b border-b-gray-350 pb-4'>
            <h2 className='text-lg font-semibold'>関連記事を選択する</h2>
            <button
              className='shrink-0'
              type='button'
              onClick={onClose}
            >
              <img
                src={CloseIcon}
                alt=''
                width='14'
                height='14'
                loading='lazy'
              />
            </button>
          </div>
          <ul className='h-[270px] overflow-y-auto'>
            {filteredItems.length === 0 ? (
              <li className='py-10 text-center text-gray-500'>まだ記事はありません</li>
            ) : (
              filteredItems.map((item: Article) => (
              <li key={item.id} className='[&:nth-child(2n)]:bg-gray-50'>
                <label className='flex cursor-pointer select-none transition-opacity hover:opacity-70'>
                  <div className='px-[30px] py-[20px]'>
                    <input
                    type='checkbox'
                    className='checkbox'
                    checked={checkedItems.has(item.id)}
                    onChange={() => onToggle(item.id)}
                    disabled={checkedItems.size >= 3 && !checkedItems.has(item.id)}
                  />
                  </div>
                  <div className='flex flex-1 items-center truncate border-l border-solid border-l-gray-200 px-4'>
                    <div className='text-xm truncate'>{item.title}</div>
                  </div>
                </label>
              </li>
                  ))
                )}
          </ul>
          <div className='mt-auto flex justify-center'>
            <div className='w-[160px]'>
              <a
                className='block cursor-pointer rounded-full border border-solid border-primary-500 px-6 py-3 text-center text-primary-500 transition-opacity hover:opacity-60'
                onClick={handleApply}
              >
                選択完了
              </a>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export { RelatedArticleModal };
